
module.exports.logOutButton = "logOut"
module.exports.clockingButton = "clocking";
module.exports.openCloseTillButton = "openCloseTill";
module.exports.openCashDrawer = "cashDrawer";
module.exports.outstanding = "outstanding";
module.exports.salesHistory = "salesHistory";
module.exports.dailySummary = "dailySummary";
module.exports.driverSales = "driverSales";
module.exports.notifications = "notifications";
module.exports.overview = "overview";
module.exports.settings = "settings";
module.exports.order = "order";
module.exports.callLogs = "callLogs";
module.exports.blank = "blank";
module.exports.navigationDesigner = "navigationDesigner";
module.exports.attendance = "attendance";
module.exports.rota = "rota";
module.exports.holidays = "holidays";
module.exports.dineIn = "dineIn";
module.exports.takeAway = "takeAway";
module.exports.collection = "collection";
module.exports.delivery = "delivery";
module.exports.staffMeal = "staffMeal";
module.exports.freebies = "freebies";
module.exports.guestMeal = "guestMeal";
module.exports.itemSnooze = "itemSnooze";
module.exports.propertySnooze = "propertySnooze";
module.exports.cashingUp = "cashingUp";
module.exports.voucher = "voucher";
module.exports.menuSnooze = "menuSnooze";